import { IBuildingType } from './building-type.model';
import httpClient from '../http/http-client';

class BuildingTypeService {
  async findAll(): Promise<IBuildingType[]> {
    try {
      const response = await httpClient.get('building-type');
      return response.data;
    } catch (error) {
      console.error('Error fetching building types:', error);
      throw error;
    }
  }

  async findOne(id: string): Promise<IBuildingType> {
    try {
      const response = await httpClient.get(`building-type/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching building type:', error);
      throw error;
    }
  }
}

export default BuildingTypeService;











